import React, { useRef, useState, useImperativeHandle, forwardRef } from "react";

const BottomBufferTextarea = forwardRef(({value: initialValue, onValue, style, ...textareaProps}, ref) => {
  const textareaRef = useRef(null);
  const [value, setValue] = useState(initialValue);

  useImperativeHandle(ref, () => ({
    scrollToBottom: () => {
      if (textareaRef.current) {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
      }
    },
    getTextarea: () => textareaRef.current,
    focus: () => textareaRef.current?.focus?.(),
    get value() {
      return textareaRef.current?.value ?? ''
    },
    setSelectionRange: (start, end) => {
      textareaRef.current?.setSelectionRange?.(start, end)
    },
  }));

  const handleInput = (e) => {
    setValue(e.target.value);

    const ta = textareaRef.current;
    const charCount = ta.value.length;

    const cursorPos = ta.selectionEnd;

    if (charCount == cursorPos) {
      ta.scrollTop = ta.scrollHeight
    }

    onValue(e.target.value)
  };

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={handleInput}
      onClick={handleInput}
      onKeyUp={handleInput}
      style={{
        ...style,
        width: "100%",
        paddingBottom: "4em",
        boxSizing: "border-box",
        overflowY: "scroll",
        fontSize: "16px",
        lineHeight: "1.5em",
      }}
      {...textareaProps}
    />
  );
});

export default BottomBufferTextarea
